export default __webpack_public_path__ + "static/media/138.12e46000.png";